import React from "react";
import PrimaryCard from "../common/cards/PrimaryCard";
import {
  Box,
  HStack,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { useAssistance, useVehicle } from "../../hooks";
import BreakdownCard from "./cards/BreakdownCard";
import { useTranslation } from "react-i18next";
import GearboxCard from "./cards/GearboxCard";
import FuelTypeCard from "./cards/FuelTypeCard";
import { Canvas } from "@react-three/fiber";
import SceneViewer from "./SceneViewer";

const VehicleCard = () => {
  const { t } = useTranslation();
  const { assistance } = useAssistance();
  const { vehicle } = useVehicle();

  return (
    <PrimaryCard
      title={t("plugin.vehicle")}
    >
      <VStack width={"full"} height={"full"} gap={"4px"}>
        <BreakdownCard zIndex={1000} minHeight={"45px"} justifySelf={"flex-start"} />
        <Box position={"relative"} width={"full"} display={"flex"} flexDirection={"row"} justifyContent={"center"}>
          {vehicle?.Vehicle?.Speed > 0 && (
            <Text position={"absolute"} color={"white"} fontSize={"14px"} top={"16px"} left={"8px"} fontWeight={"bold"} zIndex={200}>
              {vehicle?.Vehicle?.Speed || 0} km/h
            </Text>
          )}
        </Box>
        <Box as={Canvas} flexGrow={1} minHeight={"220px"} borderRadius={"7px"} backgroundColor={"#D2D2D233"}>
          <SceneViewer />
        </Box>
        <HStack width={"full"} justifyContent={"space-between"}>
          <FuelTypeCard
            colSpan={4}
            colStart={1}
            rowSpan={2}
            rowStart={10}
            vehicle={vehicle}
          />
          <Tooltip label={t("plugin.tooltips.licensePlate")} placement={"top"}>
            <HStack flexGrow={1} alignItems={"center"} justifyContent={"center"} gap={"5px"}>
              <Text fontWeight={500} fontSize={"14px"}>{assistance?.license_plate}</Text>
            </HStack>
          </Tooltip>
          <GearboxCard
            colSpan={4}
            colStart={9}
            rowSpan={2}
            rowStart={10}
            vehicle={vehicle}
            color={"#8b8c89"}
          />
        </HStack>
      </VStack>
    </PrimaryCard>
  );
};

export default React.memo(VehicleCard);
